import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-knit-stitches',
  templateUrl: './knit-stitches.component.html',
  styleUrls: ['./knit-stitches.component.css']
})
export class KnitStitchesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
